import { ComponentProps, FC } from 'react'
import { Button, ModalCenter } from 'src/components'
import { IconWelcomeToCommunity } from 'src/icons'
import { ICommunityModel } from 'src/interfaces'

interface IProps {
  community?: ICommunityModel
}

export const ModalWelcomeToCommunity: FC<ComponentProps<typeof ModalCenter> & IProps> = ({ community, ...props }) => {
  return (
    <ModalCenter
      {...props}
      contentStyles={{ maxWidth: 424 }}
      className="sm-px-5"
      contentClass="p-10 w-100-p"
    >
      <div className="fx-column fx-ai-center gap-8">
        <div className="fx-column gap-2 fx-ai-center">
          <div className="ff-rubik bold-24 txt-black-01 txt-center">
            Welcome to {community?.name} Job Community!
          </div>

          <div className="fs-14 lh-20 txt-center txt-black-02">
            Take a look around - you’ll find jobs and Vibe Checks from other awesome Hiring Managers here!
          </div>

          <IconWelcomeToCommunity/>
        </div>

        <Button
          className="w-full py-3"
          onClick={props.onClose}
        >
          Let’s Go!
        </Button>
      </div>
    </ModalCenter>
  )
}
